// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__wqfux","footerContainer":"Footer_footerContainer__P8qfp","footerText":"Footer_footerText__av45v"};